import type { ValueOf } from '@dni-types/utilities/value-of'
import { defaultStmCartValues, getStmCartValues, useStmCartSelector, useStmCartStore } from '../use-stm-cart-store'
import { useStmSyncCartSessionStore, useStmSyncCartSessionToStore } from '../use-stm-sync-cart-session-to-store'
import { defaultCartValues, getFpMerchantCartValues, useFpMerchantCartSelector, useFpMerchantCartStore } from '../useFpMerchantCartStore'
import { useFpMerchantSyncCartSessionStore, useFpMerchantSyncCartSessionToStore } from '../useFpMerchantSyncCartSessionToStore'

export const Platform = {
  STM: 'stm',
  MERCHANT: 'merchant',
} as const

export type PlatformType = ValueOf<typeof Platform>

/**
 * markCartSessionSynced：前端直接改寫本機購物車後呼叫，讓購物車頁不再拉 session 舊快照合併回來；
 * 兩個平台的 sync hook 都要對已同步的 campaign 以 null key 跳過 cart_request_cache 請求，這個標記才有效。
 * merchant 一站一個 campaign，用單一 boolean 即可，參數僅為與 STM 同型。
 */
export const cartStoreMap = {
  [Platform.STM]: {
    useCartStore: useStmCartStore,
    useCartSelector: useStmCartSelector,
    cartDefaultValues: defaultStmCartValues,
    useSyncCartSessionToStore: useStmSyncCartSessionToStore,
    getCartValues: getStmCartValues,
    markCartSessionSynced: (campaignCode: string) => useStmSyncCartSessionStore.getState().addSyncedCampaignCode(campaignCode),
  },
  [Platform.MERCHANT]: {
    useCartStore: useFpMerchantCartStore,
    useCartSelector: useFpMerchantCartSelector,
    cartDefaultValues: defaultCartValues,
    useSyncCartSessionToStore: useFpMerchantSyncCartSessionToStore,
    getCartValues: getFpMerchantCartValues,
    markCartSessionSynced: (_campaignCode: string) => useFpMerchantSyncCartSessionStore.getState().setHasFinishedSyncCartSession(true),
  },
} as const
